export const Colour = {
  None: 0,
  Black: 1,
  White: 2,
  Red: 3,
  Yellow: 4,
  Blue: 5,
  Green: 6,
  Gold: 7,
  Brown: 8,
  Orange: 9,
  Purple: 10,
  Tan: 11,
  Silver: 12,
  Teal: 13,
  Gray: 14,
  Copper: 15,
  Beige: 16,
  Burgundy: 17,
  Pink: 18,
  Other: 100,
}

export const NormalizedColours = {
  [Colour.Black]: 'Black',
  [Colour.White]: 'White',
  [Colour.Red]: 'Red',
  [Colour.Yellow]: 'Yellow',
  [Colour.Blue]: 'Blue',
  [Colour.Green]: 'Green',
  [Colour.Gold]: 'Gold',
  [Colour.Brown]: 'Brown',
  [Colour.Orange]: 'Orange',
  [Colour.Purple]: 'Purple',
  [Colour.Tan]: 'Tan',
  [Colour.Silver]: 'Silver',
  [Colour.Teal]: 'Teal',
  [Colour.Gray]: 'Gray',
  [Colour.Copper]: 'Copper',
  [Colour.Beige]: 'Beige',
  [Colour.Burgundy]: 'Burgundy',
  [Colour.Pink]: 'Pink',
  [Colour.Other]: 'Other',
}

export const ColorPalette = {
  [Colour.Black]: '#000',
  [Colour.White]: '#FFF',
  [Colour.Red]: '#D11313',
  [Colour.Yellow]: '#FFFF00',
  [Colour.Blue]: '#00F',
  [Colour.Green]: '#0E8349',
  [Colour.Gold]: '#E5B413',
  [Colour.Brown]: '#453914',
  [Colour.Orange]: '#FF7F00',
  [Colour.Purple]: '#875F9A',
  [Colour.Tan]: '#D2B48C',
  [Colour.Silver]: '#C0C0C0',
  [Colour.Teal]: '#008080',
  [Colour.Gray]: '#6F6F6F',
  [Colour.Copper]: '#B87333',
  [Colour.Beige]: '#D6D29F',
  [Colour.Burgundy]: '#800020',
  [Colour.Pink]: '#FF69B4',
  [Colour.Other]:
    'linear-gradient(red, transparent),\n' +
    '        linear-gradient(to top left, lime, transparent),\n' +
    '        linear-gradient(to top right, blue, transparent)',
}

export const FilterColourOptions = [
  { label: NormalizedColours[Colour.Black], hex: ColorPalette[Colour.Black], value: Colour.Black },
  { label: NormalizedColours[Colour.White], hex: ColorPalette[Colour.White], value: Colour.White },
  { label: NormalizedColours[Colour.Red], hex: ColorPalette[Colour.Red], value: Colour.Red },
  {
    label: NormalizedColours[Colour.Yellow],
    hex: ColorPalette[Colour.Yellow],
    value: Colour.Yellow,
  },
  { label: NormalizedColours[Colour.Blue], hex: ColorPalette[Colour.Blue], value: Colour.Blue },
  { label: NormalizedColours[Colour.Green], hex: ColorPalette[Colour.Green], value: Colour.Green },
  { label: NormalizedColours[Colour.Brown], hex: ColorPalette[Colour.Brown], value: Colour.Brown },
  {
    label: NormalizedColours[Colour.Orange],
    hex: ColorPalette[Colour.Orange],
    value: Colour.Orange,
  },
  {
    label: NormalizedColours[Colour.Purple],
    hex: ColorPalette[Colour.Purple],
    value: Colour.Purple,
  },
  { label: NormalizedColours[Colour.Tan], hex: ColorPalette[Colour.Tan], value: Colour.Tan },
  {
    label: NormalizedColours[Colour.Silver],
    hex: ColorPalette[Colour.Silver],
    value: Colour.Silver,
  },
  { label: NormalizedColours[Colour.Gray], hex: ColorPalette[Colour.Gray], value: Colour.Gray },
  {
    label: NormalizedColours[Colour.Copper],
    hex: ColorPalette[Colour.Copper],
    value: Colour.Copper,
  },
  {
    label: NormalizedColours[Colour.Other],
    hex: ColorPalette[Colour.Other],
    value: Colour.Other,
  },
]

export const InteriorColours = [
  Colour.Black,
  Colour.White,
  Colour.Red,
  Colour.Blue,
  Colour.Brown,
  Colour.Tan,
  Colour.Gray,
  Colour.Other,
]

export const ExteriorColours = [
  Colour.Black,
  Colour.White,
  Colour.Red,
  Colour.Yellow,
  Colour.Blue,
  Colour.Green,
  Colour.Brown,
  Colour.Orange,
  Colour.Purple,
  Colour.Tan,
  Colour.Silver,
  Colour.Gray,
  Colour.Copper,
  Colour.Other,
]
